<template>
  <div
    class="transferrer-dropdown-component"
    :class="{ 'transferrer-dropdown-component--min': verticalNavMenuItemsMin }"
    id="stopPropagationOfCss"
    >
    <!-- NOTIFICATIONS -->
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >
      <feather-icon
        icon="ActivityIcon"
        class="cursor-pointer transferrer-dropdown-component__icon"
        :class="{
          'transferrer-dropdown-component--min__icon': verticalNavMenuItemsMin,
          'sm:mr-6': verticalNavMenuItemsMin
        }"
        :badge="unreadNotificationsBadge"
      />

      <vs-dropdown-menu
        class="transferrer-dropdown dropdown-custom vx-navbar-dropdown"
      >

        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white">
            Transferência
          </h3>
        </div>

        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--nofications-dropdown p-0"
          :settings="settings"
          :key="$vs.rtl"
        >        
          <small class="float-right clear" @click="clearAll">Limpar</small>

          <ul class="list bordered-items" v-if="unreadNotifications.length > 0">
            <li 
              v-for="ntf in unreadNotifications"
              :key="ntf.id"
              class="flex justify-between px-4 py-4 cursor-pointer"
            >
              <div class="flex items-start">
                <div 
                  class="mx-2"
                  style="width: 325px !important;"
                  @click="openNotificationModal(ntf)"
                >
                  <div>
                    <span class="font-medium block notification-title text-primary">
                      {{ ntf.title }}
                    </span>
                  </div>
                  
                  <div class="truncate cursor-pointer">
                    <small>
                      {{ ntf.text }}
                    </small>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <p v-else class="p-3 text-center opacity-75 list">
            Nenhuma transferência
          </p>
        </VuePerfectScrollbar>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    verticalNavMenuItemsMin: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
    }
  },
  computed: {
    unreadNotificationsBadge() {
      return this.unreadNotifications.length < 10 ? this.unreadNotifications.length : '9+'
    },
    unreadNotifications() {
      return  this.$store.state.ticketTransfer ? this.$store.state.ticketTransfer.ticketTransferNotifications : []
    }
  },
  methods: {
    clearAll() {
      this.$store.dispatch('ticketTransfer/clearNotifications')
    },
    openNotificationModal(notification) {
      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: notification.title,
        text: notification.text.trim(),
        accept: () => {this.$store.dispatch("ticketTransfer/clearNotificationById", notification.id ) },
        acceptText: 'Marcar Como Lida',
        cancelText: 'Voltar',
        buttonAccept: 'flat',
        buttonCancel: 'filled'
      })
    }
  },
  created() {

  }
}

</script>

<style lang="scss">
.transferrer-dropdown-component {
  padding: 0;

  .feather-icon {
    margin-right: 0 !important;
  }

  &__icon {
    width: 15px;
    height: 15px;
  }

  &--min {
    padding: 10px 15px;

    &__icon {
      width: 16px;
      height: 16px;
    }
  }
}

.vs-dialog-text {
  white-space: pre-line;
}

.clear {
  margin: 5px 10px 5px 0px;
  cursor: pointer;
}

.list {
  margin-top: 30px;
}

.vs-button-filled {
  color: #fff !important;
}

.transferrer-dropdown {
  .truncate {
    width: 95%;
  }

  &.con-vs-dropdown--menu {
    width: auto !important;
    max-width: 365px !important;
  }
}
#stopPropagationOfCss {
  .vs-dropdown--custom.vs-dropdown--menu {
    min-height: 140px !important;
    min-width: 300px !important;
    > section {
      min-height: 140px !important;
    }
  }
}
</style>
